// extracted by mini-css-extract-plugin
export default {"modal":"DeleteCandidateGroupModal-module__modal__8A9FP","detail":"DeleteCandidateGroupModal-module__detail__RIH8i","content":"DeleteCandidateGroupModal-module__content__10IEm"};